import { SET_MODIFIER_SETTINGS_DATA_LOADING, SET_MODIFIER_SETTINGS_DATA } from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const findModifierSettings = () => async (dispatch) => {
  try {
    dispatch({ type: SET_MODIFIER_SETTINGS_DATA_LOADING, payload: true });
    const companyId = store.getState().authState.companyId;
    if (!companyId) {
      return false;
    }
    const res = await Axios.get('/api/dashboard/settings/find-modifier-settings', {
      params: { companyId },
    });
    dispatch({
      type: SET_MODIFIER_SETTINGS_DATA,
      payload: res.data.data,
    });
    return true;
  } catch (error) {
    dispatch({
      type: SET_MODIFIER_SETTINGS_DATA,
      payload: [{ param: 'is-product-modifiers-enabled', value: 'false' }],
    });
    return false;
  }
};

export const updateModifierSettings = (modifierSettings) => async (dispatch) => {
  try {
    dispatch({ type: SET_MODIFIER_SETTINGS_DATA_LOADING, payload: true });
    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    const requestBody = {
      ...(modifierSettings.modifierSettingsData || {}),
    };
    await Axios.post('/api/dashboard/settings/update-modifier-settings', requestBody, {
      params: { companyId, branchId },
    });
    dispatch({ type: SET_MODIFIER_SETTINGS_DATA_LOADING, payload: false });
    return true;
  } catch (err) {
    dispatch({ type: SET_MODIFIER_SETTINGS_DATA_LOADING, payload: false });
    return false;
  }
};
